import WorldSystem from '../WorldSystem';
import AnimationTask from '../../../Utility/Task/AnimationTask';
import GameObject from '../../../GameObject/GameObject';
import PopupTask from '../../../Utility/Task/PopupTask';
import SendCoinsTask from '../../../Utility/Task/SendCoinsTask';
import { IPlayerStateTaskData } from '../../../State/Player/IPlayerState';
import StarChestFTUXTask from '../../../Utility/Task/StarChestFTUXTask';
import QuestsFTUXTask from '../../../Utility/Task/QuestsFTUXTask';
import PetFTUXTask from '../../../Utility/Task/PetFTUXTask';
import ShowWheelTask from 'Utility/Task/ShowWheelTask';
import WheelFTUXTask from 'Utility/Task/WheelFTUXTask';
import PetWalkTask from 'Utility/Task/PetWalkTask';
import HarvestTask from 'Utility/Task/HarvestTask';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { ShowFTUXFieldUnlock } from 'System/Animation/Clip';
import WorldUISystem from 'System/UI/WorldUISystem';
import FarmBtnFTUXTask from 'Utility/Task/FarmBtnFTUXTask';
import XmasFTUXTask from "Utility/Task/XmasFTUXTask";

export default class WorldTaskHelper {
    public static iconHop(system: WorldSystem, levelNumber: number): void {
        system.taskQueue.queue(
            new AnimationTask(
                'PlayerIconHop',
                system.worldMap.playerIcon,
                { nextNode: system.getLevelNode(levelNumber) },
                false
            )
        );
    }
    public static FTUXFieldUnlock(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        const worldHudHandler = system.scene.getSystem(WorldUISystem).hud;
        const worldHUD = GameObject.findByName('worldHUD_main_element')[0];

        system.taskQueue.queue(new AnimationClipTask(new ShowFTUXFieldUnlock(worldHUD, {
            harvestButton: worldHudHandler.harvestButton,
            mainContainer: worldHudHandler.mainContainer,
        })));
    }
    public static ShowPopup(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new PopupTask(taskData));
    }
    public static SendCoins(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new SendCoinsTask(taskData));
    }
    public static StarChestFTUX(system: WorldSystem, taskData: { starChestLevel: number }): void {
        system.taskQueue.queue(new StarChestFTUXTask(taskData.starChestLevel));
    }
    public static QuestFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new QuestsFTUXTask());
    }
    public static PetUnlockFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new PetFTUXTask(taskData.petLevel, taskData.petId));
    }
    public static PetWalk(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(
            new PetWalkTask(taskData.currentWorldMaxLevel, taskData.endLevel, taskData.startLevel, taskData.petId)
        );
    }
    public static ShowWheel(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new ShowWheelTask(taskData.luckyWheel)
            // new AnimationClipTask(new Alpha(taskData.wheelContainer, {
            //     startAlpha: 0,
            //     endAlpha: 1,
            //     delay: 600,
            //     duration: 500
            // }))
        )
    }
    public static WheelFTUX(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(new WheelFTUXTask(taskData.firstWheelLevel));
    }
    public static Harvest(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new HarvestTask(taskData.rewardData, taskData.coinAmount, taskData.playAutoFlow));
    }
    public static FarmBtnFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new FarmBtnFTUXTask());
    }
    public static XmasFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new XmasFTUXTask());
    }
}
